import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ChecklistIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsxs(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Checklist",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M14 21.29c-.29 0-.58-.11-.81-.33l-2.29-2.29c-.45-.45-.45-1.17 0-1.62s1.17-.45 1.62 0L14 18.53l6.05-6.05c.45-.45 1.17-.45 1.62 0s.45 1.17 0 1.62l-6.86 6.86c-.22.22-.52.33-.81.33"
    }), /*#__PURE__*/_jsx("path", {
      d: "M24.29 29.29h-16c-1.89 0-3.43-1.54-3.43-3.43V5.29a1.14 1.14 0 1 1 2.28 0v20.57c0 .63.51 1.14 1.14 1.14h16c.63 0 1.14-.51 1.14-1.14V5.29a1.14 1.14 0 1 1 2.28 0v20.57c0 1.89-1.54 3.43-3.43 3.43Z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M22 8.71H10.57c-.63 0-1.14-.51-1.14-1.14V3c0-.63.51-1.14 1.14-1.14H22c.63 0 1.14.51 1.14 1.14v4.57c0 .63-.51 1.14-1.14 1.14M11.71 6.43h9.14V4.15h-9.14z"
    })]
  }));
};
ChecklistIcon.displayName = 'ChecklistIcon';